var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-2 pr-2 pt-0 pb-2"},[_c('model-entry',_vm._g({attrs:{"model":_vm.source}},_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }